export default {"src":"/_next/static/media/microscope.2ea47e75.svg","height":27,"width":27};